/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 2 hook(s) need dependency review; fix each and remove this directive */
import { useDispatch, useSelector } from "react-redux";
import { modulesNameSynonymMapper } from "../../services/constants";
import { defaultModuleNamesMapper, defaultModulesMapper, formCategories, LAYOUTS_SIDEBAR_CELL_ID } from "@Helpers";
import { getBackendUrl } from "@Utils";
import { useCallback, useEffect, useState } from "react";
import axiosWrapper from "@AxiosWrapper";
import { useTranslation } from "@i18n";
import { getPortalCustomModules } from "../../actions/portalSetting.helper";
import { setProjectSideBarIconsAndNameMapper } from "../../reducers/projectSetting";
import { RootState } from "@Reducers/index";

function useStickySidebar({ layout, projectId, path, isFocused = true, mobile = false }: any) {
  const { t } = useTranslation();

  const customModules = useSelector((state: RootState) => state.customModules) || [];
  const portalData = useSelector((state: RootState) => state.portalData);

  const [sideBarMidIcons, setSideBarMidIcons] = useState<any[]>([]);
  const [sideBarUpperFixedIcons, setSideBarUpperFixedIcons] = useState<any[]>([]);
  const [sideBarLowerFixedIcons, setSideBarLowerFixedIcons] = useState<any[]>([]);
  const [counts, setCounts] = useState<Record<string, number> | null>(null);

  const isRustomjeePortal = portalData?.frontendUrl?.includes("rustomjee") || false;
  const isDpmsPortal = portalData?.frontendUrl?.includes("dpmsportal") || false;

  const dispatch = useDispatch();

  const fetchModulesCount = useCallback(async () => {
    const res = await axiosWrapper.post<{ status: boolean; data: Record<string, number> }>(
      `${getBackendUrl()}/projects/getModulesCount`,
      {
        projectId,
      },
    );
    if (res.data.status) {
      setCounts(res.data.data);
    }
  }, [projectId]);

  useEffect(() => {
    if (isFocused && customModules) {
      setCounts(null);
      if (mobile) {
        fetchModulesCount();
      }
    }
  }, [isFocused, customModules, fetchModulesCount, mobile]);

  useEffect(() => {
    dispatch(getPortalCustomModules());
  }, []);

  function getCount(key: string) {
    return counts == null ? null : (counts[key] ?? 0);
  }

  useEffect(() => {
    const projectSideBarIcons: any = [
      {
        id: "Home",
        allow: !!path.Dashboard,
        path: path.Dashboard && path.Dashboard(projectId),
        name: t("Home"),
        svg: "HomeIcon",
        toolTip: isDpmsPortal ? `${modulesNameSynonymMapper.project} Dashboard` : t("Project Dashboard"),
        position: "upper",
      },
      {
        id: defaultModuleNamesMapper[defaultModulesMapper.SPACES],
        allow: path.WorkspacesList && layout.SPACES?.ENABLE,
        path: path.WorkspacesList && path.WorkspacesList(projectId),
        count: getCount("Spaces"),
        // TODO: add additional properitey type because in dpmsportal, it is not highlighting
        name: isDpmsPortal ? `${modulesNameSynonymMapper.spaces}` : t("Spaces"),
        svg: "SpacesIcon",
        toolTip: isDpmsPortal ? `${modulesNameSynonymMapper.spaces}` : t("Spaces"),
        position: "mid",
      },
      {
        id: defaultModuleNamesMapper[defaultModulesMapper.TRANSMITTALS],
        allow: path.Transmittals && layout.TRANSMITTAL?.ENABLE,
        path: path.Transmittals && path.Transmittals(projectId),
        count: getCount("Transmittals"),
        name: t("Transmittals"),
        svg: "TransmittalIcon",
        toolTip: t("Transmittals"),
        position: "mid",
      },
      {
        id: defaultModuleNamesMapper[defaultModulesMapper.ISSUES],
        allow: path.Issues && layout.ISSUES?.ENABLE,
        path: path.Issues && path.Issues(projectId),
        count: getCount("Issues"),
        name: t("Issues"),
        svg: "IssuesIcon",
        toolTip: t("Issues"),
        position: "mid",
      },
      {
        id: defaultModuleNamesMapper[defaultModulesMapper.TASKS],
        allow: path.Tasks && layout.TASKS?.ENABLE,
        path: path.Tasks && path.Tasks(projectId),
        count: getCount("Tasks"),
        name: t("Tasks"),
        svg: "TasksIcon",
        toolTip: t("Tasks"),
        position: "mid",
      },
      {
        id: defaultModuleNamesMapper[defaultModulesMapper.REVIEWS],
        allow: path.Reviews && layout.WORKFLOW?.ENABLE,
        path: path.Reviews && path.Reviews(projectId),
        count: getCount("Reviews"),
        name: t("Reviews"),
        svg: "Review",
        toolTip: t("Reviews"),
        position: "mid",
      },
      {
        id: defaultModuleNamesMapper[defaultModulesMapper.ASSETS],
        allow: path.Assets && layout.ASSETS?.ENABLE,
        path: path.Assets && path.Assets(projectId),
        count: getCount("Assets"),
        name: t("Assets"),
        svg: "Assets",
        toolTip: t("Assets"),
        position: "mid",
      },
      {
        id: defaultModuleNamesMapper[defaultModulesMapper.MAILBOX],
        allow: path.Mailbox && layout.MAILBOX?.ENABLE,
        path: path.Mailbox && path.Mailbox(projectId),
        name: t("Mailbox"),
        svg: "Mailbox",
        toolTip: t("Mailbox"),
        position: "mid",
      },
      {
        id: defaultModuleNamesMapper[defaultModulesMapper.FILES],
        allow: path.Files && layout.FILES?.ENABLE,
        path: path.Files && path.Files(projectId),
        count: getCount("Files"),
        name: t("Files"),
        svg: "FilesIcon",
        toolTip: t("Files"),
        position: "mid",
      },
      // {
      //   id:"Change Order",
      //   allow: layout.FILES?.ENABLE,
      //   path: '/changeOrderList',
      //   name: 'Change Order',
      //   svg: 'MdOutlineChangeCircle',
      //   toolTip: 'Change Order',
      // position : "mid"
      // },
      {
        id: defaultModuleNamesMapper[defaultModulesMapper.ESTIMATES],
        allow: path.Estimates && layout.ESTIMATES?.ENABLE,
        path: path.Estimates && path.Estimates(projectId),
        count: getCount("Estimates"),
        name: t("Estimates"),
        svg: "EstimateIcon",
        toolTip: t("Estimates"),
        position: "mid",
      },
      {
        id: defaultModuleNamesMapper[defaultModulesMapper.SCHEDULES],
        allow: path.Schedules && layout.SCHEDULES?.ENABLE,
        path: path.Schedules && path.Schedules(projectId),
        count: getCount("Schedules"),
        name: t("Schedules"),
        svg: "ScheduleIcon",
        toolTip: t("Schedules"),
        position: "mid",
      },
      {
        id: defaultModuleNamesMapper[defaultModulesMapper.CONTRACTS],
        allow: path.Contract && layout.CONTRACT?.ENABLE,
        count: getCount("Contracts"),
        historyPush: false,
        path: path.Contract && path.Contract(projectId),
        name: t("Contracts"),
        svg: "Contracts",
        toolTip: t("Contracts"),
        position: "mid",
      },
      {
        id: defaultModuleNamesMapper[defaultModulesMapper.INSPECTION],
        allow: path.Forms && layout.INSPECTION?.ENABLE,
        count: getCount(formCategories.inspection),
        path: path.Forms && path.Forms(projectId, formCategories.inspection),
        name: isRustomjeePortal ? "Work Done" : t("Inspections"),
        svg: "inspectionForm",
        toolTip: `${isRustomjeePortal ? "Work Done Forms" : t("Inspection Forms")}`,
        position: "mid",
      },
      {
        id: defaultModuleNamesMapper[defaultModulesMapper.PROGRESS_UPDATES],
        allow: path.Forms && layout.PROGRESS_UPDATES?.ENABLE,
        count: getCount(formCategories.progressUpdates),
        path: path.Forms && path.Forms(projectId, formCategories.progressUpdates),
        name: t("Progress Updates"),
        svg: "ProgressUpdates",
        toolTip: t("Progress Updates"),
        position: "mid",
      },
      {
        id: defaultModuleNamesMapper[defaultModulesMapper.BILLS],
        allow: path.Forms && layout.BILLS?.ENABLE,
        count: getCount(formCategories.bills),
        path: path.Forms && path.Forms(projectId, formCategories.bills),
        name: t("Bills"),
        svg: "bills",
        toolTip: t("Bills"),
        position: "mid",
      },
      {
        id: defaultModuleNamesMapper[defaultModulesMapper.CHANGE_ORDER],
        allow: path.Forms && layout.CHANGE_ORDER?.ENABLE,
        count: getCount(formCategories.changeOrder),
        path: path.Forms && path.Forms(projectId, formCategories.changeOrder),
        name: t("Change Orders"),
        svg: "changeOrder",
        toolTip: t("Change Orders"),
        position: "mid",
      },
      {
        id: defaultModuleNamesMapper[defaultModulesMapper.PHOTOS],
        // Always visible for now; gate with `layout.PHOTOS?.ENABLE` once the backend layout flag exists.
        allow: !!path.Photos,
        path: path.Photos && path.Photos(projectId),
        name: t("Photos"),
        svg: "image",
        toolTip: t("Photos"),
        position: "mid",
      },
      {
        id: "Payments",
        allow: false,
        count: getCount(formCategories.payments),
        path: path.Forms && path.Forms(projectId, formCategories.payments),
        name: t("Payments"),
        svg: "Payments",
        toolTip: t("Payments"),
        position: "mid",
      },
      // {
      //   id:"Tenders",
      //   allow: layout.TENDER_LIST?.ENABLE,
      //   path: '/tendersList',
      //   name: 'Tenders',
      //   svg: 'TendersIcon',
      //   toolTip: 'Tenders',
      // position : "mid"
      // },
      // {
      //   id: "Asset Register",
      //   allow: layout.ASSET_REGISTER?.ENABLE,
      //   path: '/assetRegister',
      //   name: 'Asset Register',
      //   svg: 'AssetRegisterIcon',
      //   toolTip: 'Asset Register',
      // position : "mid"
      // },
      // {
      //   id:"Procurement",
      //   allow: layout.PROCUREMENT?.ENABLE,
      //   path: '/procurement',
      //   name: 'Procurement',
      //   svg: 'ProcurementIcon',
      //   toolTip: 'Procurement',
      // position : "mid"
      // },
      // {
      //   id: "Workflows",
      //   allow: layout.WORKFLOW?.ENABLE,
      //   path: '/workflow',
      //   name: 'Workflows',
      //   svg: 'TiFlowChildren',
      //   toolTip: 'Workflows',
      // position : "mid"
      // },
      // {
      //   id: "ChangeOrder",
      //   allow: layout.CHANGE_ORDER?.ENABLE,
      //   path: '/changeOrder',
      //   name: 'ChangeOrder',
      //   svg: 'RiExchangeBoxLine',
      //   toolTip: 'Change Order',
      // position : "mid"
      // },
      {
        id: defaultModuleNamesMapper[defaultModulesMapper.CLASH],
        showBetaTag: true,
        allow: path.GeneralClash && layout.CLASH?.ENABLE,
        path: path.GeneralClash && path.GeneralClash(projectId),
        name: t("Clash"),
        svg: "ClashIcon",
        toolTip: t("Clash"),
        position: "mid",
      },
      {
        id: LAYOUTS_SIDEBAR_CELL_ID,
        allow: true,
        name: t("Layouts"),
        svg: "MoreOptions",
        toolTip: t("Layouts"),
        position: "bottom",
      },
      {
        id: "Settings",
        allow: true,
        path: path.Settings && path.Settings(projectId),
        name: t("Settings"),
        svg: "SettingsIcon",
        toolTip: isDpmsPortal ? `${modulesNameSynonymMapper.project} Settings` : t("Project Settings"),
        position: "bottom",
      },
    ];

    customModules.map((module: any) => {
      projectSideBarIcons.push({
        id: module.name,
        allow: !!path.Forms,
        path: path.Forms && path.Forms(projectId, module.resourceType),
        count: getCount(module.resourceType),
        name: module.name,
        svg: module.icon,
        toolTip: module.name,
        position: "mid",
      });
    });
    dispatch(
      setProjectSideBarIconsAndNameMapper(
        projectSideBarIcons.map(({ id, name, svg, toolTip }) => {
          return { id, name, svg, toolTip };
        }),
      ),
    );
    setSideBarMidIcons(projectSideBarIcons.filter((icon: any) => icon.position == "mid"));
    setSideBarUpperFixedIcons(projectSideBarIcons.filter((icon: any) => icon.position == "upper"));
    setSideBarLowerFixedIcons(projectSideBarIcons.filter((icon: any) => icon.position == "bottom"));
  }, [layout, projectId, customModules, counts, portalData]);

  return { sideBarMidIcons, sideBarUpperFixedIcons, sideBarLowerFixedIcons };
}

export default useStickySidebar;
